import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { RewardResponseDTO } from 'src/app/shared/models/dtos/responses/reward-response-dto/reward-response-dto';
import { RewardLabels } from 'src/app/shared/models/reward-labels/reward-labels';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-reward-card-slim',
  templateUrl: './reward-card-slim.component.html',
  styleUrls: ['./reward-card-slim.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Reward Card Slim alternative
 */
export class RewardCardSlimComponent implements OnInit {
  @Input() reward?: RewardResponseDTO;
  @Input() index?: string;
  rewardLabels = new RewardLabels();
  RoutesKeys = RoutesKeys;
  language = '';

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private readonly router: Router
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.translationService.translateObject(this.rewardLabels);
    this.language = this.translationService.getActiveLang();
  }

  /**
   * onRoute
   */
  onRoute() {
    this.router.navigate([RoutesKeys.REWARDS, this.reward?.id]);
  }

  /**
   * Handles image access error on s3
   */
  handleImageError() {
    this.reward!.imgSource = '';
  }
}
